module.exports = __webpack_public_path__ + "static/media/40.4f276f8f.jpg";